import { render } from "./IsLoadingComponent.vue?vue&type=template&id=2a17679a&scoped=true"
import script from "./IsLoadingComponent.vue?vue&type=script&lang=js"
export * from "./IsLoadingComponent.vue?vue&type=script&lang=js"

import "./IsLoadingComponent.vue?vue&type=style&index=0&id=2a17679a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a17679a"]])

export default __exports__